<template>
    <div class="pt-2 pb-10 pr-2 container-imagenes">
        <draggable item-key="url" ghost-class="ghost" chosen-class="chosen" animation="300" :touch-start-threshold="10"
            :delay="100" :delay-on-touch-only="true" :force-fallback="true" :list="imagenesGrandes" :disabled="false"
            class=" grid-imagenes" @change="cambiarOrden" draggable=".item">
            <div v-for="(item, index) in imagenesGrandes" class="imagen-card item">
                <img :src="item.url" :alt="index" class="imagen-car " style="">
                <div class="d-flex justify-center" style="gap: 8px;">
                    <v-btn icon small color="icon">
                        <v-icon @click="modalVerImagen(item.url)" small color="info">fas fa-eye</v-icon>
                    </v-btn>
                    <v-btn icon small color="icon">
                        <BtnConfirmar icono="fas fa-trash" color="error" icon_button small
                            :texto="`¿Está seguro que desea eliminar esta imagen?`" @action="eliminarImagen(item)" />
                    </v-btn>
                </div>
            </div>
            <div>
                <img @click="agregarUnaImagen" src="/plus-img.svg" :alt="'nueva imagen'" class="imagen-car plus-img"
                    style="margin: 1rem; cursor: pointer; border: dashed 2px #9f9f9f;">
            </div>
            <div class="" style="position: absolute; right: 30px; bottom: 40px;">
                <BtnConfirmar @action="guardarCambios()" />
            </div>
        </draggable>
        <ImgViewer v-model="modalImagen" :img="imagenSeleccionada" :nombre="imagenSeleccionada" />
        <NuevaImagen v-model="modalNuevaImagen" :tipo="'grandes'" />
    </div>
</template>

<script>
import draggable from "vuedraggable";
import ImgViewer from "../../util/ImgViewer.vue";
import BtnConfirmar from "../../util/BtnConfirmar.vue";
import NuevaImagen from "./NuevaImagen.vue";

export default {
    data() {
        return {
            modalImagen: false,
            modalNuevaImagen: false,
            imagenSeleccionada: '',

            imagenesGrandes: [
                {
                    url: 'https://images.pexels.com/photos/26146550/pexels-photo-26146550/free-photo-of-paisaje-montanas-naturaleza-viaje.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
                },
                {
                    url: 'https://images.pexels.com/photos/31198323/pexels-photo-31198323/free-photo-of-paseo-panoramico-a-caballo-por-el-norte-de-mindanao.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
                },
                {
                    url: 'https://images.pexels.com/photos/27846554/pexels-photo-27846554/free-photo-of-reflejo-reflexion-chrome-cromo.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
                },
                {
                    url: 'https://images.pexels.com/photos/31109871/pexels-photo-31109871/free-photo-of-acogedora-escena-callejera-nocturna-en-fukuoka.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
                },
                {
                    url: 'https://images.pexels.com/photos/26146550/pexels-photo-26146550/free-photo-of-paisaje-montanas-naturaleza-viaje.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
                },
                {
                    url: 'https://images.pexels.com/photos/31198323/pexels-photo-31198323/free-photo-of-paseo-panoramico-a-caballo-por-el-norte-de-mindanao.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
                },
                {
                    url: 'https://images.pexels.com/photos/27846554/pexels-photo-27846554/free-photo-of-reflejo-reflexion-chrome-cromo.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
                },
                {
                    url: 'https://images.pexels.com/photos/31109871/pexels-photo-31109871/free-photo-of-acogedora-escena-callejera-nocturna-en-fukuoka.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
                },
            ]
        };
    },
    props: {
        vehiculo: {}
    },
    methods: {
        cambiarOrden() {
            console.log("cambio el orden");
        },
        async agregarUnaImagen() {
            console.log("funcion para agregar una imagen");
            this.modalNuevaImagen = true
        },

        modalVerImagen(url) {
            console.log("ver imagen");
            this.modalImagen = true
            this.imagenSeleccionada = url
        },

        modalEliminar() {
            console.log("Confirmar eliminacion");
        },

        async eliminarImagen(item) {
            console.log(item);
        },

        async guardarCambios() {
            console.log("cambios guardados o no");

        },
    },
    watch: {
        imagenesGrandes(val) {
            console.log(val);
        }
    },
    components: {
        draggable,
        ImgViewer,
        BtnConfirmar,
        NuevaImagen
    },
};
</script>


<style>
.container-imagenes {
    height: 450px;
    overflow-x: hidden;
    overflow-y: scroll;
    margin-bottom: 10px;
}

.grid-imagenes {
    height: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
}

.imagen-card {
    padding: 1rem;
}

.imagen-car {
    max-width: 200px;
    height: auto;
    aspect-ratio: 1/1;
    object-fit: cover;
}
</style>